import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { s as state } from './index3.js';

import { baseCss } from './css.js';
const nlInfoExtensionCss = baseCss;

const NlInfoExtensionStyle0 = nlInfoExtensionCss;

const NlInfoExtension = /*@__PURE__*/ proxyCustomElement(class NlInfoExtension extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("div", { key: '9335feb745c6d09a213a2e771c40262036341b54', class: "p-4 overflow-y-auto" }, state.isLoadingExtension ? (h("div", null, h("h1", { class: "nl-title font-bold text-center text-4xl" }, "Signing in..."), h("div", { class: "mt-10 mb-10 ml-auto mr-auto w-20" }, h("span", { slot: "icon-start", class: "animate-spin-loading ml-auto mr-auto inline-block w-20 h-20 border-[4px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" })), h("div", { class: "ps-4 pe-4 overflow-y-auto" }, h("p", { class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)))) : (h("div", null, h("h1", { class: "nl-title font-bold text-center text-4xl" }, "Install browser extension!"), h("p", { class: "nl-description font-light text-center text-lg pt-2 max-w-96 mx-auto" }, "Try", ' ', h("a", { href: "https://getalby.com", target: "_blank" }, "Alby"), ",", ' ', h("a", { href: "https://chromewebstore.google.com/detail/nos2x/kpgefcfmnafjgpblomihpgmejjdanjjp", target: "_blank" }, "nos2x"), ' ', "or", ' ', h("a", { href: "https://apps.apple.com/us/app/nostore/id1666553677", target: "_blank" }, "Nostore"))))));
    }
    static get style() { return NlInfoExtensionStyle0; }
}, [0, "nl-info-extension"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-info-extension"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-info-extension":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlInfoExtension);
            }
            break;
    } });
}
defineCustomElement();

export { NlInfoExtension as N, defineCustomElement as d };

//# sourceMappingURL=nl-info-extension2.js.map